import styles from './AchievedCorrection.module.css';
import { MetricSession } from '../../models/CaseTypes';

import { logTrace } from '../../utils/trackingUtils';
import MeshViewer from '../CaseViewer/MeshViewer';

interface SpineViewerProps {
  id: string;
  metricSessions: MetricSession[];
  onSessionChange: (selectedValue: string) => void;
  session: MetricSession | null;
  signedUrl: string | null;
  selectedPlaneNames: string[];
  selectedVertebraeNames: string[];
}

const SpineViewer = (
  {
    id,
    metricSessions,
    onSessionChange,
    session,
    selectedPlaneNames,
    selectedVertebraeNames,
    signedUrl
  } : SpineViewerProps
): React.JSX.Element  => {

  if (!session) {
    return (
      <div></div>
    );
  }

  return (
    <div className={styles['three-d-view-parent-container']}>
      <select
        className={styles['three-d-view-dropdown']}
        data-testid={id}
        id={id}
        value={session.sessionName}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onSessionChange(e.target.value)}
      >
        {metricSessions.map(session => (
          <option key={`prim_${session.sessionName}`} value={session.sessionName}>
            {session.sessionDescription}
          </option>
        ))}
      </select>
      
      <div className={styles['three-d-view-container']}>
        {signedUrl ? (
          <div onMouseEnter={
            () => logTrace('AchievedCorrection', 'proprio_view_corr_mesh_', session.sessionNameShorthand || '')
          }>
            <MeshViewer
              signedUrl={signedUrl}
              selectedNames={selectedVertebraeNames}
              selectedPlaneNames={selectedPlaneNames}
            />
          </div>
        ) : (
          <div style={{
            height: '350px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f0f0f0',
            color: '#666'
          }}>
            3D View not available
          </div>
        )}
      </div>
    </div>
  );
};

export default SpineViewer;
